<template lang="pug">
div(:class="[\'vs-notify\', group]" :style="styles")
  transition-group(:name="trans" mode="out-in")
    div(:class="it.type" v-for="it in list" :key="it.id")
      slot(name="body" :class="it.type" :item="it" :close="function(){ end(it) }")
        div(@click.stop="end(it)" v-html="it.text")
</template>

<script>
import "./notify.scss";
/*=============================================================================
  Created by NxtChg (admin@nxtchg.com), 2017. License: Public Domain.
=============================================================================*/
export default {
  props: {
    group: {
      type: String,
      default: () => "",
    },
    transition: {
      type: String,
      default: () => "",
    },
    position: {
      type: String,
      default: "top right",
    },
    duration: {
      type: Number,
      default: 3000,
    },
    reverse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const p = this.position;
    let d = !this.reverse;
    let t = this.transition;

    if (p.indexOf("bottom") + 1) {
      d = !d;
    }

    if (!t && p.indexOf("left") + 1) {
      t = "ntf-left";
    }

    if (!t && p.indexOf("right") + 1) {
      t = "ntf-right";
    }

    return {
      dir: d,
      trans: t,
      list: [],
    };
  },

  //destroyed: function(){ }, // do we need it? if so - remove group from VsNotify

  computed: {
    styles() {
      const s = {};
      const pa = this.position.split(" ");

      for (var i = 0; i < pa.length; i++) {
        if (pa[i] == "center") {
          s.left = s.right = 0;
          s.margin = "auto";
        } else if (pa[i] != "") {
          s[pa[i]] = 0;
        }
      }

      return s;
    },
  },
  created() {
    let ids = 1;

    this.$notify.groups[this.group] = (text, type, time) => {
      if (text === undefined) {
        this.end();
        return;
      }

      var it = { id: ids++, text: text, type: "ntf" + (type ? " " + type : "") };

      time = time !== undefined ? time : this.duration;

      if (time > 0) {
        it.timer = setTimeout(() => {
          this.end(it);
        }, time);
      }

      this.dir ? this.list.push(it) : this.list.unshift(it);
    };
  },

  methods: {
    find(id) {
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].id == id) {
          return i;
        }
      }

      return -1;
    },
    end_no(n) {
      if (n + 1) {
        clearTimeout(this.list[n].timer);
        this.list.splice(n, 1);
      }
    },
    end(it) {
      if (it === undefined) {
        while (this.list.length) {
          this.end_no(0);
        }
        return;
      } // kill all

      this.end_no(this.find(it.id));
    },
  },
};
</script>
